import React, { useEffect, useState } from 'react';
import Editor from '@monaco-editor/react';
import axios from 'axios';
import { Button, Box, Spinner } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { updateLuaScript } from '../actions/luaAction';

const LuaEditor = ({ luaSID, luaScriptTxt }) => {
  const [luaScript, setLuaScript] = useState('');
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();


  useEffect(() => {
    console.log("---", luaScriptTxt)
    setLuaScript(luaScriptTxt || '');
    setLoading(false)
    // Fetch Lua script for a specific game
    // axios.get(`/api/lua-script/${luaSID}`)
    //   .then((res) => {
    //     setLuaScript(res.data.luaScript || '');
    //     setLoading(false);
    //   })
    //   .catch(() => {
    //     setLuaScript('-- No script found');
    //     setLoading(false);
    //   });
  }, [luaSID]);

  const handleSave = async () => {
    try {
      await dispatch(updateLuaScript(luaSID, luaScript));
      alert('Lua script saved successfully!');
    } catch (err) {
      console.error(err);
      alert('Error saving script: ' + (err.message || 'Unknown error'));
    }
  };

  if (loading) return <Spinner />;

  return (
    <Box>
      <Editor
        height="500px"
        defaultLanguage="lua"
        value={luaScript}
        onChange={setLuaScript}
        theme="vs-dark"
      />
      <Button mt={4} colorScheme="blue" onClick={handleSave}>
        Save Script
      </Button>
    </Box>
  );
};

export default LuaEditor;
